/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useMemo, useEffect } from 'react';
import CustomTable from 'components/cmn/CustomTable';
import { useProject } from 'hooks/useProject';
import { AccountProjectTableHead } from 'components/cmn/CustomTableHeadWrapper';
import AccountProjectListTableBody from './AccountProjectListTableBody';

function AccountProjectListTable({ id, type }: { id: string; type: 'admin' | 'manager' }): JSX.Element {
  const { getProjectListByAccount, changeCmnPageAndSize, accountsListSearchCondition } = useProject();
  const { data, isLoading, duration } = getProjectListByAccount(id || '');
  const { page, size } = accountsListSearchCondition;

  const projectList = useMemo(() => {
    return data?.contents || [];
  }, [data?.contents]);

  const totalCount = useMemo(() => {
    return data?.totalCount ?? 0;
  }, [data?.totalCount]);

  const handleChangePage = (event: unknown, newPage: number): any => {
    changeCmnPageAndSize('accountsListSearchCondition', newPage, size);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const _rowsPerPage = parseInt(event.target.value, 10);
    changeCmnPageAndSize('accountsListSearchCondition', 0, _rowsPerPage);
  };

  useEffect(() => {
    if (page !== 0 && totalCount !== 0 && projectList.length === 0) {
      changeCmnPageAndSize('accountsListSearchCondition', page - 1, size);
    }
  }, [changeCmnPageAndSize, page, projectList.length, size, totalCount]);

  return (
    <CustomTable
      count={totalCount}
      rowsPerPage={size}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      isLoading={isLoading}
      maxHeight="calc(100vh - 550px)"
      duration={duration}
    >
      <AccountProjectTableHead order="desc" orderBy="id" />
      <AccountProjectListTableBody loading={isLoading} rows={projectList} duration={duration} type={type} />
    </CustomTable>
  );
}

export default memo(AccountProjectListTable);
